module.exports = __webpack_public_path__ + "img/success.a5acff97.png";